import React, { useEffect, useState } from 'react';
import Service from '../services/Service';
import '../styles/Dashboard.css';
import { FaUsers, FaShoppingCart } from 'react-icons/fa';
import UserDashboard from '../../../Patient/Dashboard/pages/Dashboard';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchText, setSearchText] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await Service.getCountofOrder();
        setData(response.data);
      } catch (error) {
        console.error('❌ Error fetching dashboard data:', error);
      } finally {
        setLoading(false);
      }
    };

    const fetchUsers = async () => {
      try {
        const res = await Service.getPatientList(); // pagination=no
        setUsers(res.data?.results || []);
      } catch (err) {
        console.error('❌ Error fetching users:', err);
      }
    };

    fetchStats();
    fetchUsers();
  }, []);

  if (loading) return <div className="loader">Loading Dashboard...</div>;
  if (!data) return <div className="error">Failed to load data</div>;

  const { total_users, total_orders } = data;

  const filteredUsers = users.filter((user) => {
    const text = searchText.toLowerCase();
    return user.first_name?.toLowerCase().includes(text) || user.email?.toLowerCase().includes(text);
  });

  return (
    <div className="dashboard-wrapper">
      <h2 className="dashboard-heading">📊 Admin Overview</h2>

      {/* Summary Cards */}
      <div className="summary-grid">
        <div className="summary-card gradient-green clickable" onClick={() => navigate('/admin/patient-list')} style={{ cursor: 'pointer' }}>
          <div className="summary-icon">
            <FaUsers />
          </div>
          <div>
            <h3>Total Patients</h3>
            <p>{total_users}</p>
          </div>
        </div>

        <div className="summary-card gradient-blue">
          <div className="summary-icon">
            <FaShoppingCart />
          </div>
          <div>
            <h3>Total Orders</h3>
            <p>{total_orders}</p>
          </div>
        </div>
      </div>

      {/* User Dropdown */}
      <div className="user-dropdown-section">
        <label>Select a Patient to view dashboard:</label>

        <div className="admin-user-dropdown">
          {/* Dropdown Header */}
          <div className="admin-dropdown-header" onClick={() => setIsDropdownOpen((prev) => !prev)}>
            <span>{selectedUser ? `${selectedUser.first_name || 'No Name'} — ${selectedUser.email}` : '-- Select User --'}</span>
            <span className="admin-dropdown-arrow">{isDropdownOpen ? '▲' : '▼'}</span>
          </div>

          {/* Dropdown Body */}
          {isDropdownOpen && (
            <div className="admin-dropdown-body">
              {/* Search Box */}
              <input
                type="text"
                placeholder="Search user..."
                className="admin-dropdown-search"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />

              {/* List */}
              <div className="admin-dropdown-list">
                {filteredUsers.length > 0 ? (
                  filteredUsers.map((user) => (
                    <div
                      key={user.id}
                      className="admin-dropdown-item"
                      onClick={() => {
                        setSelectedUser(user);
                        setIsDropdownOpen(false);
                        setSearchText(''); // reset search
                      }}
                    >
                      {user.first_name || 'No Name'} — {user.email}
                    </div>
                  ))
                ) : (
                  <div className="admin-dropdown-item no-results">No Users Found</div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Render User Dashboard Below */}
      {selectedUser && (
        <div className="user-dashboard-preview">
          <h3 className="dashboard-subheading">👤 Viewing {selectedUser.first_name || selectedUser.email}’s Dashboard</h3>
          <UserDashboard userId={selectedUser.id} userName={selectedUser.first_name} isAdminView={true} />
        </div>
      )}
    </div>
  );
};

export default Dashboard;
